import { el } from "./dom.js";

// Downward chevron signalling the title opens the project switcher.
const CHEVRON =
  '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" ' +
  'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ' +
  'focusable="false"><path d="M6 9l6 6 6-6" /></svg>';

// The tappable project title in the top-left: live status dot + project name
// (+ an optional "· suffix" for the current page) + a chevron. Tapping it opens
// the project switcher — the Slack/Linear workspace-switcher idiom. The caller
// owns `dot` so its live online/offline state keeps updating after this renders.
export function projectTitle(
  dot: HTMLElement,
  name: string,
  suffix: string | null,
  onSwitch: () => void,
): HTMLElement {
  const chevron = el("span", { class: "title-chevron" });
  chevron.innerHTML = CHEVRON;
  const label = suffix ? `${name} · ${suffix}` : name;
  return el(
    "button",
    { class: "topbar-title", type: "button", "aria-label": "Switch project", onclick: onSwitch },
    [dot, el("span", { class: "title-name" }, [label]), chevron],
  );
}
